import DashboardLoading from "./dashboardLoading";

export default DashboardLoading;